import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = { class: "text-start" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }
const _hoisted_4 = { class: "row row-cols-1" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row row-cols-1 row-cols-md-2 row-cols-lg-4" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "d-flex mb-2 pl-2 justify-content-end"
}
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "align-self-end" }
const _hoisted_16 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("TPS_Performance_Tracking")), 1)
    ]),
    _createVNode(_component_el_form, {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
      class: "mt-2",
      "label-position": 'right',
      "label-width": 'auto'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('form.label.period')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.searchCriteria.lastPeriodCnt,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCriteria.lastPeriodCnt) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_1_period")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_2_period")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 4 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_4_period")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 6 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_6_period")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 10 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_10_period")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('PJCode') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchCriteria.projectCodeKeyword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchCriteria.projectCodeKeyword) = $event)),
                  modelModifiers: { trim: true },
                  onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                  clearable: "",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "onKeyup", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('top_pn') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchCriteria.pnKeyword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchCriteria.pnKeyword) = $event)),
                  modelModifiers: { trim: true },
                  onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                  clearable: "",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "onKeyup", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('site') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: _ctx.t('placeholder.select'),
                  loading: _ctx.isSiteLoading,
                  "loading-text": _ctx.t('loading'),
                  onVisibleChange: _ctx.onSiteListShown,
                  modelValue: _ctx.searchCriteria.site,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchCriteria.site) = $event)),
                  "value-key": "id",
                  class: "w-100",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchCriteria.factory = undefined)),
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: site.id,
                        label: site.name,
                        value: site
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["placeholder", "loading", "loading-text", "onVisibleChange", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('factory') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.searchCriteria.factory,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchCriteria.factory) = $event)),
                  "value-key": "id",
                  class: "w-100",
                  clearable: "",
                  placeholder: _ctx.t('placeholder.select')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchCriteria.site?.factories, (factory) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: factory.id,
                        label: factory.name,
                        value: factory
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_el_button, {
        type: "",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onBtnClearSearchClicked()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("clear")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onBtnSearchTableListClicked()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("search")), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_12,
    (_ctx.userInfoStore.permissions.some(x=> [120].includes(x)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_el_button, {
            onClick: _ctx.onExportReportClicked,
            disabled: _ctx.displayList.length == 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("export")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_el_popover, {
          placement: "bottom",
          onHide: _ctx.onColDisplayCtrlPanelHidded,
          trigger: "click",
          Title: _ctx.t('column')
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, { link: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Operation)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[0],
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.colDisplayCtrl[0]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("implement_day")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[1],
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.colDisplayCtrl[1]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("site")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[2],
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.colDisplayCtrl[2]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("factory")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[3],
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.colDisplayCtrl[3]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("endCustomer")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[4],
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.colDisplayCtrl[4]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("period")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[5],
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.colDisplayCtrl[5]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("startMonth")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[6],
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.colDisplayCtrl[6]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("endMonth")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[7],
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.colDisplayCtrl[7]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("PJCode")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[8],
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.colDisplayCtrl[8]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("top_pn")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[9],
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.colDisplayCtrl[9]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("payRate")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[10],
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.colDisplayCtrl[10]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("area_before_improvement")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[11],
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.colDisplayCtrl[11]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("area_after_improvement")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[12],
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.colDisplayCtrl[12]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("processing_leadtime_before_improvement")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[13],
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.colDisplayCtrl[13]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("processing_leadtime_after_improvement")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[14],
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.colDisplayCtrl[14]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("vender_leadtime_before_improvement")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[15],
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.colDisplayCtrl[15]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("vender_leadtime_after_improvement")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[16],
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.colDisplayCtrl[16]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("pph_before_improvement")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[17],
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.colDisplayCtrl[17]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("pph_after_improvement")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[18],
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.colDisplayCtrl[18]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("org_std_process_time")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[19],
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.colDisplayCtrl[19]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("std_process_time")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[20],
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.colDisplayCtrl[20]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("std_process_time_diff")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[21],
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.colDisplayCtrl[21]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("std_process_time_diff_ratio")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[22],
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.colDisplayCtrl[22]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("material_costs")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[23],
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.colDisplayCtrl[23]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("stock_in_num")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[24],
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.colDisplayCtrl[24]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("total_workhour")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[25],
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.colDisplayCtrl[25]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("current_pph")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[26],
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.colDisplayCtrl[26]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("process_LT")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[27],
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.colDisplayCtrl[27]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("workhour_performance")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[28],
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.colDisplayCtrl[28]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("pph_performance")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[29],
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.colDisplayCtrl[29]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("lt_performance")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[30],
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.colDisplayCtrl[30]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("vender_lt_performance")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[31],
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.colDisplayCtrl[31]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("co2_emission")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["onHide", "Title"])
      ]),
      _createVNode(_component_el_table, {
        class: "w-100",
        data: _ctx.displayList,
        stripe: true,
        onSortChange: _ctx.onSortChanged
      }, {
        default: _withCtx(() => [
          (_ctx.colDisplayCtrl[0])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                "min-width": "120",
                prop: "implementDay",
                label: _ctx.t('implement_day')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[1])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                "min-width": "120",
                prop: "siteName",
                label: _ctx.t('site')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[2])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                "min-width": "120",
                prop: "factoryName",
                label: _ctx.t('factory')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[3])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                "min-width": "120",
                prop: "customerName",
                label: _ctx.t('endCustomer')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[4])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                "min-width": "120",
                prop: "periodNum",
                label: _ctx.t('period')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[5])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                "min-width": "120",
                prop: "startMonth",
                label: _ctx.t('startMonth')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[6])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 6,
                "min-width": "120",
                prop: "endMonth",
                label: _ctx.t('endMonth')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[7])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 7,
                "min-width": "120",
                prop: "projectCode",
                label: _ctx.t('PJCode')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[8])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 8,
                "min-width": "120",
                prop: "topPN",
                label: _ctx.t('top_pn')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[9])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 9,
                "min-width": "120",
                prop: "workRate",
                label: _ctx.t('payRate')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[10])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 10,
                "min-width": "120",
                prop: "areaBeforeImp",
                label: _ctx.t('area_before_improvement')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[11])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 11,
                "min-width": "120",
                prop: "procLTBeforeImp",
                label: _ctx.t('area_after_improvement')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[12])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 12,
                "min-width": "120",
                prop: "venderLTBeforeImp",
                label: _ctx.t('processing_leadtime_before_improvement')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[13])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 13,
                "min-width": "120",
                prop: "pphBeforeImp",
                label: _ctx.t('processing_leadtime_after_improvement')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[14])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 14,
                "min-width": "120",
                prop: "areaAfterImp",
                label: _ctx.t('vender_leadtime_before_improvement')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[15])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 15,
                "min-width": "120",
                prop: "venderLTAfterImp",
                label: _ctx.t('vender_leadtime_after_improvement')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[16])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 16,
                "min-width": "120",
                prop: "procLTAfterImp",
                label: _ctx.t('pph_before_improvement')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[17])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 17,
                "min-width": "120",
                prop: "pphAfterImp",
                label: _ctx.t('pph_after_improvement')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[18])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 18,
                "min-width": "120",
                prop: "stdProcTimeOrg",
                label: _ctx.t('org_std_process_time')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[19])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 19,
                "min-width": "120",
                prop: "stdProcTime",
                label: _ctx.t('std_process_time')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[20])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 20,
                "min-width": "120",
                prop: "stdProcTimeDiff",
                label: _ctx.t('std_process_time_diff')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[21])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 21,
                "min-width": "120",
                prop: "stdProcTimeDiffRatio",
                label: _ctx.t('std_process_time_diff_ratio')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[22])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 22,
                "min-width": "120",
                prop: "materialCosts",
                label: _ctx.t('material_costs')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[23])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 23,
                "min-width": "120",
                prop: "stockInNum",
                label: _ctx.t('stock_in_num')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[24])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 24,
                "min-width": "120",
                prop: "totalWorkHour",
                label: _ctx.t('total_workhour')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[25])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 25,
                "min-width": "120",
                prop: "currentPPH",
                label: _ctx.t('current_pph')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[26])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 26,
                "min-width": "120",
                prop: "procLT",
                label: _ctx.t('process_LT')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[27])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 27,
                "min-width": "120",
                "prop工資率": "工資率workHourPerf",
                label: _ctx.t('workhour_performance')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[28])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 28,
                "min-width": "120",
                prop: "pphPerf",
                label: _ctx.t('pph_performance')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[29])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 29,
                "min-width": "120",
                prop: "ltPerf",
                label: _ctx.t('lt_performance')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[30])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 30,
                "min-width": "120",
                prop: "venderLTPref",
                label: _ctx.t('vender_lt_performance')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[31])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 31,
                "min-width": "120",
                prop: "co2Emission",
                label: _ctx.t('co2_emission')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data", "onSortChange"])
    ]),
    _createVNode(_component_el_row, {
      justify: "end",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_pagination, {
                currentPage: _ctx.searchCriteria.page,
                "onUpdate:currentPage": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.searchCriteria.page) = $event)),
                "page-size": _ctx.searchCriteria.pageSize,
                "onUpdate:page-size": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.searchCriteria.pageSize) = $event)),
                "pager-count": _ctx.paginatorSetup.pagerCount,
                layout: _ctx.paginatorSetup.layout,
                small: _ctx.paginatorSetup.small,
                "page-sizes": _ctx.pageSize,
                total: _ctx.filteredTotal,
                onSizeChange: _ctx.onPagesizeChanged,
                onCurrentChange: _ctx.onCurrentPageChanged,
                justify: "end"
              }, null, 8, ["currentPage", "page-size", "pager-count", "layout", "small", "page-sizes", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ])), [
    [
      _directive_loading,
      _ctx.isPageLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}